import { useCallback } from "react";
import { View } from "react-native";
import styles from './EspaceValideur.styles';
import { DemandeAbsenceProps} from "../DemandeAbsence";
import ContenuEspaceValideur from "./ContenuEspaceValideur";

export default function EspaceValideur({ navigation }: DemandeAbsenceProps) {
    const openPlanning = useCallback(() => {
        navigation.navigate('Planning')
    }, [navigation])

    return (
        <View style={styles.container}>

            <ContenuEspaceValideur openPlanning={openPlanning} />
        </View>
    )
}

